import * as React from "react";
import { useTranslation } from "react-i18next";
import { getEnterpriseGroupSyncPlugin } from "util/AuthenticationService";
import { EnterprisePluginNotFound } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import EditLinkButton from "./EditLinkButton";
import { STEP_KEY as GROUP_SYNC_KEY } from "../BackendWizard/GroupSyncStep";
const GroupSyncSection = ({ authenticationBackend, roles, excludedFields = void 0 }) => {
  const { t } = useTranslation("authentication");
  const enterpriseGroupSyncPlugin = getEnterpriseGroupSyncPlugin();
  const GroupSyncSectionPlugin = enterpriseGroupSyncPlugin == null ? void 0 : enterpriseGroupSyncPlugin.components.GroupSyncSection;
  if (!GroupSyncSectionPlugin) {
    return /* @__PURE__ */ React.createElement(
      SectionComponent,
      {
        title: t("config_details.group_sync_title"),
        headerActions: /* @__PURE__ */ React.createElement(EditLinkButton, { authenticationBackendId: authenticationBackend.id, stepKey: GROUP_SYNC_KEY })
      },
      /* @__PURE__ */ React.createElement(EnterprisePluginNotFound, { featureName: t("config_details.group_sync_feature_name") })
    );
  }
  return /* @__PURE__ */ React.createElement(
    GroupSyncSectionPlugin,
    {
      authenticationBackend,
      excludedFields,
      roles
    }
  );
};
export default GroupSyncSection;
